import React from 'react';
import Home from './Home';

const NotFound = () => {
  return (
    <div>
      <Home />
      {/* <h1>Not Found</h1>
      <p className='lead'>The page you are looking for does not exist...</p> */}
    </div>
  );
};

export default NotFound;
